//mapping numbers AKA ratio numbers
function getRatio(mapHigh, mapLow, numHigh) {
  return (numHigh * mapLow) / mapHigh;
}
export function getRatio16to9(high) {
  return getRatio(16, 9, high);
}
